// Pages
export { default as DashboardPage } from './pages/DashboardPage';
export { default as DashboardOverviewPage } from './pages/DashboardOverviewPage';
export { default as SessionDetailsPage } from './pages/SessionDetailsPage';

// Components
export { default as MetricCard } from './components/MetricCard';
export { default as FilterBar } from './components/FilterBar';
export { default as SessionsTable } from './components/SessionsTable';
export { default as SessionHeader } from './components/SessionHeader';
export { default as StatsCards } from './components/StatsCards';
export { default as CallsTable } from './components/CallsTable';

// Overview Components
export { default as KpiCard } from './components/kpi/KpiCard';
export { default as KpiCardSkeleton } from './components/kpi/KpiCardSkeleton';
export { default as KpiStrip } from './components/kpi/KpiStrip';
export { default as CallsOverTimeChart } from './components/charts/CallsOverTimeChart';
export { default as DispositionPieChart } from './components/charts/DispositionPieChart';
export { default as SdrLeaderboard } from './components/charts/SdrLeaderboard';
export { default as PipelineFunnelChart } from './components/charts/PipelineFunnelChart';
export { default as RecentSessionsTable } from './components/activity/RecentSessionsTable';
export { default as DashboardTabs } from './components/shared/DashboardTabs';

// Hooks
export { default as useDashboardApi } from './hooks/useDashboardApi';
export { default as useDashboardViewModel } from './hooks/useDashboardViewModel';
export { default as useDashboardOverviewVM } from './hooks/useDashboardOverviewVM';
export { default as useSessionDetailsViewModel } from './hooks/useSessionDetailsViewModel';

// Store
export { useDashboardStore } from './store/useDashboardStore';

// Types (dashboard-specific)
export type {
  DatePreset,
  DateRange,
  DashboardFilters,
  ContactListType,
  DashboardSession,
  DashboardMetrics,
  ApiError,
  ApiResponse,
  PaginatedResponse,
  SessionDetails,
  SessionDetailsInfo,
  SessionDetailsCall,
  SessionStats,
  SessionRecordings,
  CallRecording,
  CallAction,
  CallDisposition,
  LoadingState,
} from './types/dashboard.types';

// Overview types (re-exported from @types)
export type {
  KpiValue,
  DashboardOverview,
  DashboardOverviewKpis,
  TimeSeriesPoint,
  DispositionSlice,
  SdrRanking,
  FunnelStage,
  OverviewGranularity,
  OverviewQueryParams,
} from '@types';

export {
  DEFAULT_FILTERS,
  getDateRangeFromPreset,
} from './types/dashboard.types';
